import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { ZusatzadresseTypLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';
import { MenuPlacement } from 'react-select/src/types';
import { ZusatzadresseTyp } from 'api/zusatzadresse';

interface ZusatzadresseTypProps {
    disabled: boolean;
    value: ZusatzadresseTyp;
    menuPlacement?: MenuPlacement;
    onChange: (newValue: ZusatzadresseTyp) => void;
}

export const ZusatzadresseTypSelect: React.FC<ZusatzadresseTypProps> = ({
    value,
    disabled,
    onChange,
    menuPlacement = 'bottom',
}) => {
    return (
        <>
            <Label>Typ</Label>
            <Select
                name="zusatzadressetyp"
                isDisabled={disabled}
                menuPlacement={menuPlacement}
                value={
                    value
                        ? {
                              value,
                              label: ZusatzadresseTypLabel[value] || value,
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={Object.keys(ZusatzadresseTypLabel).map((key) => ({
                    value: key,
                    label: ZusatzadresseTypLabel[key],
                }))}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange((option?.value as ZusatzadresseTyp) || 'L');
                }}
            />
        </>
    );
};
